import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import { callAPI, IsSmallScreen, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";
import { useDispatch } from "react-redux";
import { resetDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";


export const ProductList: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const isMobile = IsSmallScreen();
    const navigate = useNavigate();
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getProductPermission;

    const {
        open,
        title,
        onConfirm,
        handleClose,
        openConfirmDialog,
    } = useConfirmDialog();

    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`products`, Method.DELETE, null, id);
        dispatch(resetDataComponent('productListGrid'));
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };
    useEffect(() => {
        updateMainHeader("Products");
        breadCrumbsStore.updateBreadCrumbs([
            { "Products": "" },
        ]);
    });
    const source = {
        url: "products/search",
        page: 1,
        pageSize: 10,
        filter: [

        ],
        sort: [{
            "field": "UpdatedAt",
            "direction": "desc"
        }],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/product/edit/${row?.id}`)
        } else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }

    };


    const columns: IColumns[] = [
        // {
        //     header: "ID",
        //     fieldName: "id",
        //     type: "default",
        //     //  sortable: true
        //   },
        {
            header: "Name",
            fieldName: "name",
            type: "default",
            //  sortable: true
        },
        {
            header: "Code",
            fieldName: "code",
            tooltip: true,
            type: "default",
        },
        {
            header: "Unit",
            fieldName: "unit",
            tooltip: true,
            isHide: isMobile,
            type: "default",
        },
        {
            header: "Unit Price",
            fieldName: "unitPrice",
            isHide: isMobile,
            type: "default",
        },


        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined, "Delete"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
        },

    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Full Name",
            fieldName: "fullName",
            type: "default",
            labelSx: { fontWeight: 'bold' }
        },
        {
            header: "Email",
            fieldName: "email",
            tooltip: true,
            type: "default",
        },
        {
            header: "Phone",
            fieldName: "phoneNumber",
            tooltip: true,

            type: "default",
        },
        {
            header: "Created On",
            fieldName: "createdAt",
            isBoderRadious: true,
            type: "date",
        },
        {
            header: "Updated On",
            fieldName: "updatedAt",
            isBoderRadious: true,
            type: "date",
        },

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
        },


    ];
    const handleClick = () => {
        navigate('/product/add')
    }

    const transFormData = (data: any) => {
        if (data) {
            data.map((item: any) => {
                item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ''}`;
            })
            return data
        }
    }
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="productListGrid"
                        title="Products"
                        columns={columns}
                        source={source}
                        transFormData={transFormData}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handleClick}
                        searchBox={{ fieldName: 'name,code' }}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {/* {isMobile &&
                        <WSMobileDataGridAdvanced title={'Users'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} transFormData={transFormData} columns={mobColumns} id="userListGrid" source={source} />
                    } */}
                </Grid> : <PermissionDenied />
                }
            </Grid>
            <ConfirmDialog
                open={open}
                title={title}
                onConfirm={onConfirm}
                onClose={handleClose}
            />
        </>
    )
})